(function () {
  var ENDPOINT = 'https://api.judge.me/reviews/all_reviews_js_based';
  var MAX_PAGES = 8;
  var PER_PAGE = 50;

  var BLOB_ODD =
    '<svg viewBox="0 0 278 300" aria-hidden="true" focusable="false"><path fill="currentColor" d="M235.864 7.10152C204.635 -13.8518 166.448 13.7063 135.639 61.6587C99.5126 42.6961 59.132 42.5033 30.379 52.763C9.64112 60.9609 -0.752815 77.3662 0.0423991 107.583C0.756391 136.877 12.6516 179.984 34.7865 220.291C55.2117 257.426 80.5188 282.285 105.503 291.358C110.287 295.224 115.749 297.826 121.859 298.92C131.873 300.737 142.758 298.303 153.966 292.664C165.339 289.006 175.912 282.736 185.099 274.132C190.706 268.873 195.494 262.998 199.466 256.611C221.873 233.205 243.065 206.202 258.303 177.949C274.816 147.401 280.895 117.199 276.751 85.2612C272.68 54.2467 258.393 21.4796 235.864 7.09365L235.864 7.10152Z"/></svg>';

  var BLOB_EVEN =
    '<svg viewBox="0 0 283 309" aria-hidden="true" focusable="false"><path fill="currentColor" d="M177.13 72.0073C194.946 36.3297 194.946 24.9856 186.034 15.153C177.13 6.52484 159.315 -0.583981 141.5 0.0379382C123.685 0.667729 105.877 9.02036 96.9659 31.2599C88.0622 52.2949 88.0622 87.2326 105.87 113.259C70.247 57.2151 25.7129 68.8112 7.89771 84.8236C-1.00597 93.5698 -3.23385 108.669 5.66982 134.884C10.1256 147.7 17.3603 163.107 27.9329 176.269C38.5056 189.038 52.4239 199.572 70.2391 193.478C52.4239 199.572 38.5134 194.825 27.9329 191.699C17.3603 188.172 10.1177 186.275 5.66982 188.904C-3.23385 193.494 -1.01384 217.025 7.89771 238.91C25.7129 284.829 70.247 304.022 105.87 236.666C88.0544 272.352 88.0544 283.688 96.9659 293.521C105.87 302.149 123.685 309.257 141.5 308.636C159.315 308.006 177.123 299.653 186.034 277.414C194.938 256.379 194.938 221.441 177.13 195.415C212.753 251.458 257.287 239.862 275.102 223.85C284.006 215.104 286.234 200.005 277.33 173.789C272.874 160.973 265.64 145.567 255.067 132.404C244.494 119.635 230.576 109.102 212.761 115.195C230.576 109.102 244.487 113.849 255.067 116.974C265.648 120.501 272.882 122.399 277.33 119.769C286.234 115.18 284.014 91.649 275.102 69.7637C257.287 23.8441 212.753 4.6512 177.13 72.0073Z"/></svg>';

  var STAR =
    '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path fill="currentColor" d="M10 1.6l2.2 5.1 5.5.5-4.2 3.6 1.3 5.4L10 13.4 5.2 16.2l1.3-5.4L2.3 7.2l5.5-.5L10 1.6z"/></svg>';

  function boot() {
    document.querySelectorAll('[data-trusted-reviews]:not([data-ready])').forEach(init);
  }

  function init(root) {
    root.setAttribute('data-ready', 'true');
    var shop = root.getAttribute('data-shop');
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 8;
    var designMode = root.getAttribute('data-design-mode') === 'true';
    var track = root.querySelector('[data-track]');
    var status = root.querySelector('[data-status]');

    if (!shop || !track) return;

    loadReviews(shop, limit)
      .then(function (reviews) {
        if (!reviews.length) {
          if (designMode && status) {
            status.textContent = 'No 5-star Judge.me reviews with a photo yet.';
          } else {
            var section = root.closest('.shopify-section');
            if (section) section.style.display = 'none';
          }
          return;
        }

        if (status) status.hidden = true;
        render(track, reviews);
        startSlider(root, track, reviews.length);
      })
      .catch(function () {
        if (designMode && status) {
          status.textContent = 'Judge.me reviews could not be loaded.';
        } else {
          var section = root.closest('.shopify-section');
          if (section) section.style.display = 'none';
        }
      });
  }

  function loadReviews(shop, limit) {
    var hosts = [ENDPOINT, 'https://cdn.judge.me/reviews/all_reviews_js_based'];
    var shopNames = [shop];
    if (window.Shopify && Shopify.shop && Shopify.shop !== shop) shopNames.push(Shopify.shop);

    function attempt(hostIndex, shopIndex) {
      return fetchReviews(hosts[hostIndex], shopNames[shopIndex], limit).catch(function () {
        if (shopIndex + 1 < shopNames.length) return attempt(hostIndex, shopIndex + 1);
        if (hostIndex + 1 < hosts.length) return attempt(hostIndex + 1, 0);
        return [];
      });
    }

    return attempt(0, 0);
  }

  function fetchReviews(endpoint, shop, limit) {
    var collected = [];
    var seen = {};

    function next(page) {
      if (collected.length >= limit || page > MAX_PAGES) {
        return Promise.resolve(collected.slice(0, limit));
      }

      var params = new URLSearchParams({
        url: shop,
        shop_domain: shop,
        platform: 'shopify',
        per_page: String(PER_PAGE),
        page: String(page),
        review_type: 'product-reviews',
        filter_rating: '5',
        sort_by: 'pictures-first'
      });

      return fetch(endpoint + '?' + params.toString())
        .then(function (response) {
          if (!response.ok) throw new Error('Judge.me request failed');
          return response.json();
        })
        .then(function (data) {
          var pageData = parsePage(data && data.html);
          if (!pageData.total) return collected.slice(0, limit);

          var fresh = 0;
          pageData.ids.forEach(function (id) {
            if (!id || seen[id]) return;
            seen[id] = true;
            fresh += 1;
          });
          pageData.reviews.forEach(function (review) {
            if (collected.length >= limit || seen['photo:' + review.id]) return;
            seen['photo:' + review.id] = true;
            collected.push(review);
          });

          if (!fresh) return collected.slice(0, limit);
          return next(page + 1);
        });
    }

    return next(1);
  }

  function parsePage(html) {
    var doc = new DOMParser().parseFromString(html || '', 'text/html');
    var nodes = doc.querySelectorAll('.jdgm-rev');
    var ids = [];
    var reviews = [];

    Array.prototype.forEach.call(nodes, function (node) {
      var id = node.getAttribute('data-review-id') || '';
      if (id) ids.push(id);

      var rating = node.querySelector('.jdgm-rev__rating');
      var score = rating ? Number(rating.getAttribute('data-score')) : 0;
      var imageNode = node.querySelector('.jdgm-rev__pic-img');
      var link = node.querySelector('.jdgm-rev__pic-link');
      var src = link ? link.getAttribute('data-mfp-src') || '' : '';
      if (!src && imageNode) src = imageNode.getAttribute('data-src') || imageNode.getAttribute('src') || '';
      var image = safeImage(src);
      if (score !== 5 || !image) return;

      var titleNode = node.querySelector('.jdgm-rev__title');
      var bodyNode = node.querySelector('.jdgm-rev__body');
      reviews.push({
        id: id || image,
        image: image,
        title: titleNode ? titleNode.textContent.replace(/\s+/g, ' ').trim() : '',
        product: (node.getAttribute('data-product-title') || '').trim(),
        url: safePath(node.getAttribute('data-product-url') || ''),
        body: bodyNode ? bodyNode.textContent.replace(/\s+/g, ' ').trim() : ''
      });
    });

    return { total: nodes.length, ids: ids, reviews: reviews };
  }

  function safeImage(src) {
    try {
      var url = new URL(src, window.location.origin);
      if (url.protocol !== 'https:' && url.protocol !== 'http:') return '';
      url.protocol = 'https:';
      if (!/(^|\.)judgeme\.com$|(^|\.)judge\.me$/i.test(url.hostname)) return '';
      url.searchParams.set('width', '480');
      url.searchParams.set('quality', '80');
      return url.href;
    } catch (error) {
      return '';
    }
  }

  function safePath(path) {
    if (!path || path.charAt(0) !== '/' || path.charAt(1) === '/') return '';
    return path;
  }

  function render(track, reviews) {
    var stars = new Array(5).fill(STAR).join('');
    reviews.forEach(function (review, index) {
      var card = document.createElement(review.url ? 'a' : 'div');
      card.className = 'trusted-reviews__card';
      card.setAttribute('role', 'listitem');
      if (review.url) card.href = review.url;

      var media = document.createElement('div');
      media.className = 'trusted-reviews__media';
      media.innerHTML = '<span class="trusted-reviews__blob">' + (index % 2 === 0 ? BLOB_ODD : BLOB_EVEN) + '</span>';

      var photo = document.createElement('img');
      photo.className = 'trusted-reviews__photo';
      photo.src = review.image;
      photo.alt = review.product ? review.product + ' review photo' : 'Customer review photo';
      photo.loading = 'lazy';
      photo.width = 256;
      photo.height = 256;
      media.appendChild(photo);

      var copy = document.createElement('div');
      copy.className = 'trusted-reviews__copy';

      var rating = document.createElement('p');
      rating.className = 'trusted-reviews__rating';
      rating.innerHTML =
        '<span class="trusted-reviews__stars" role="img" aria-label="5 star review">' + stars + '</span>';
      var score = document.createElement('span');
      score.className = 'trusted-reviews__score';
      score.textContent = '5.0';
      rating.appendChild(score);

      var title = document.createElement('p');
      title.className = 'trusted-reviews__title';
      title.textContent = review.title;

      var product = document.createElement('p');
      product.className = 'trusted-reviews__product';
      product.textContent = review.product;

      copy.appendChild(rating);
      if (review.title) copy.appendChild(title);
      if (review.product && review.product.toLowerCase() !== review.title.toLowerCase()) copy.appendChild(product);
      if (review.body) {
        var quote = document.createElement('p');
        quote.className = 'trusted-reviews__quote';
        quote.textContent = '\u201C' + review.body + '\u201D';
        copy.appendChild(quote);
      }

      card.appendChild(media);
      card.appendChild(copy);
      track.appendChild(card);
    });
  }

 function startSlider(root, track, count) {
  if (count < 2) return;

  var viewport = track.parentNode;
  var index = 0;
  var timer = 0;
  var paused = false;

  for (var copy = 0; copy < count; copy += 1) {
    var clone = track.children[copy].cloneNode(true);
    if (clone.tagName === 'A') clone.tabIndex = -1;
    clone.setAttribute('aria-hidden', 'true');
    track.appendChild(clone);
  }

  function metrics() {
    var w = window.innerWidth;
    var visible = w < 590 ? 1 : 2;        // 1 card below 590px, 2 cards from 590px up
    var gap = w < 590 ? 24 : (w < 990 ? 32 : 48);

    // usable width = clientWidth minus the viewport's own padding
    var cs = window.getComputedStyle(viewport);
    var padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
    var available = viewport.clientWidth - padX;

    var card = Math.floor((available - gap * (visible - 1)) / visible);

    track.style.gap = gap + 'px';
    Array.prototype.forEach.call(track.children, function (cardEl) {
      cardEl.style.boxSizing = 'border-box';
      cardEl.style.flex = '0 0 ' + card + 'px';
      cardEl.style.width = card + 'px';
      cardEl.style.minWidth = card + 'px';
      cardEl.style.maxWidth = card + 'px';
    });
    return card + gap;
  }

  function go(nextIndex, animate) {
    var step = metrics();
    index = nextIndex;
    track.style.transition = animate ? 'transform 0.7s ease' : 'none';
    track.style.transform = 'translate3d(' + (-index * step) + 'px, 0, 0)';
  }

  function advance() {
    if (paused) return;
    var next = index + 1;
    go(next, true);
    if (next < count) return;
    window.setTimeout(function () {
      if (index !== count) return;
      go(0, false);
    }, 750);
  }

  function play() {
    window.clearInterval(timer);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    timer = window.setInterval(advance, 3500);
  }

  viewport.addEventListener('mouseenter', function () { paused = true; });
  viewport.addEventListener('mouseleave', function () { paused = false; });
  window.addEventListener('resize', function () { go(index, false); });
  window.addEventListener('orientationchange', function () { go(index, false); });

  go(0, false);
  play();
}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-trusted-reviews]');
    if (root) root.removeAttribute('data-ready');
    boot();
  });
})();
